import { withNamespaces } from "react-i18next";
import { Button, Spinner } from "reactstrap";

/**
 * Save control shared by every assessment. It replaces the questionnaire
 * library's built-in submit button so the saving state can come from the
 * mutation of the assessment that renders it.
 */
const AssessmentSaveButton = ({ t, isSaving = false, disabled = false, onClick }) => {
    return (
        <Button
            type="button"
            color="primary"
            className="ms-auto"
            disabled={isSaving || disabled}
            onClick={onClick}
        >
            {isSaving ? (
                <>
                    <Spinner size="sm" color="white" className="me-1" />
                    {`${t("Saving")}...`}
                </>
            ) : (
                t("Save")
            )}
        </Button>
    );
};

export default withNamespaces()(AssessmentSaveButton);
